import { getRequiredEnvVar } from '../environment';
import ApiInternalClient from '../../../generated/api-internal';
import ApiProxy from './api-proxy';

const client = new ApiInternalClient({
  host: getRequiredEnvVar('FLOW_API_URI'),
});

export default new ApiProxy(client);
